import { Component } from '@angular/core';

@Component({
  selector: 'am-layout-app',
  templateUrl: './layout-app.component.html',
  styleUrls: ['./layout-app.component.scss'],
})
export class LayoutAppComponent {}
